/**------------------------------------------------------
 * Interface Definitions
 */
export interface ILegalCookiesBannerStorage {
	setDate		: Date;
	socialMedia	: boolean;
	analytics	: boolean;
}


/**------------------------------------------------------
 * Configurations
 */
export const LEGAL_INITIAL_COOKIES_STORAGE: ILegalCookiesBannerStorage = {
	setDate		: new Date(new Date().setDate(new Date().getDate() - 1)),		// set to the previous day
	socialMedia	: false,
	analytics	: false
};
